export default __webpack_public_path__ + "static/media/mariano.c3251467.jpeg";